import React from "react";
import {
  IoGlobeOutline,
  IoTimeOutline,
  IoDocumentTextOutline,
  IoBookOutline,
  IoCartOutline,
} from "react-icons/io5";
import { FaEnvelope, FaFileAlt, FaBookmark, FaCheck } from "react-icons/fa";

const ReportDetailsSidebar = ({
  report,
  onBuyNow,
  onDownloadSample,
  onRequestCustomization,
  onAddReport,
  isSaved,
  isSampleRequested = false,
  isCustomizationRequested = false,
}) => {
  return (
    <div className="card border-0 shadow-sm bg-white mb-4 mb-lg-0 overflow-hidden">
      <div className="hero-gradient-bg p-2 border-bottom">
        <h4 className="fw-bold text-dark mb-0 px-2 sidebar-heading">
          Report Details
        </h4>
      </div>
      <div
        className="p-lg-3 p-2"
        style={{
          background:
            "linear-gradient(0deg, rgb(136 158 237 / 25%) 0%, transparent 100%)",
          borderBottom: "1px solid #dee2e6",
        }}
      >
        <div className="mb-3 reportDetaislItem">
          <div className="d-flex align-items-center gap-lg-2 gap-1 mb-1 text-nowrap">
            <IoGlobeOutline className="commonColor" />
            <span className="fw-bold sidebar-label">Geographic Coverage</span>
          </div>
          <p className="text-secondary ms-4 mb-0 sidebar-value">
            {report?.RegionsCovered || "Asia Pacific"}
          </p>
        </div>

        <div className="mb-3">
          <div className="d-flex align-items-center gap-lg-2 gap-1 mb-1 text-nowrap">
            <IoTimeOutline className="commonColor" />
            <span className="fw-bold sidebar-label">Forecast Period</span>
          </div>
          <p className="text-secondary ms-4 mb-0 sidebar-value">
            {report.StudyPeriod || "2024 - 2030"}
          </p>
        </div>

        <div className="mb-3">
          <div className="d-flex align-items-center gap-lg-2 gap-1 mb-1 text-nowrap">
            <IoDocumentTextOutline className="commonColor" />
            <span className="fw-bold sidebar-label">Report Format</span>
          </div>
          <div className="ms-4 mb-0 sidebar-value d-flex align-items-center gap-2 pt-1">
            {[
              { type: "PDF", color: "#e21f26" },
              { type: "XLS", color: "#1D6F42" },
              { type: "PPT", color: "#D83B01" },
            ].map((fmt, i) => (
              <div
                key={i}
                className="d-flex flex-column align-items-center"
                style={{ position: "relative", width: "22px" }}
              >
                <svg
                  width="20"
                  height="24"
                  viewBox="0 0 20 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 0H13L20 7V25C20 25.5523 19.5523 26 19 26H1C0.447715 26 0 25.5523 0 25V1C0 0.447715 0.447715 0 1 0Z"
                    fill="#CBD5E1"
                  />
                  <path d="M13 0L20 7H13V0Z" fill="#94A3B8" />
                </svg>
                <div
                  style={{
                    position: "absolute",
                    bottom: "3px",
                    left: "1px",
                    right: "1px",
                    backgroundColor: fmt.color,
                    color: "#fff",
                    fontSize: "6px",
                    fontWeight: "900",
                    padding: "1px 0",
                    borderRadius: "1px",
                    textAlign: "center",
                    lineHeight: "1",
                  }}
                >
                  {fmt.type}
                </div>
              </div>
            ))}
          </div>
        </div>

        {Boolean(report.Pages) && String(report.Pages) !== "0" && (
          <div className="mb-3">
            <div className="d-flex align-items-center gap-lg-2 gap-1 mb-1 text-nowrap">
              <IoBookOutline className="commonColor" />
              <span className="fw-bold sidebar-label">Pages</span>
            </div>
            <p className="text-secondary ms-4 mb-0 sidebar-value">
              {report.Pages}
            </p>
          </div>
        )}

        <div className="d-flex flex-column gap-3 mt-4 mb-2 w-100 px-lg-2 px-1">
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 transition rounded-pill border-0 report-action-btn"
            style={{
              color: isSaved ? "#198754" : "#024ed6",
              backgroundColor: isSaved ? "#e8f5e9" : "#eef2ff",
              fontSize: "0.85rem",
            }}
            onClick={onAddReport}
            aria-label={isSaved ? "Report Saved" : "Add Report"}
          >
            {isSaved ? (
              <FaCheck size={12} style={{ color: "#198754" }} />
            ) : (
              <FaBookmark size={12} style={{ color: "#024ed6" }} />
            )}
            <span className="fw-semibold">
              {isSaved ? "Report Saved" : "Add Report"}
            </span>
          </button>
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 transition rounded-pill border-0 report-action-btn"
            style={
              isSampleRequested
                ? { backgroundColor: "#198754", color: "#ffffff", fontSize: "0.85rem", opacity: 0.95, cursor: "not-allowed" }
                : { color: "#4a6582", fontSize: "0.85rem" }
            }
            onClick={onDownloadSample}
            disabled={isSampleRequested}
            title={isSampleRequested ? "Sample already requested within the last 7 days" : "Request a Sample"}
            aria-label="Request a Sample"
          >
            {isSampleRequested ? (
              <FaCheck size={12} style={{ color: "#ffffff" }} />
            ) : (
              <FaEnvelope size={12} style={{ color: "#6ca0ff" }} />
            )}
            <span className="fw-semibold">
              {isSampleRequested ? "Sample Requested" : "Sample"}
            </span>
          </button>
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 transition rounded-pill border-0 report-action-btn"
            style={
              isCustomizationRequested
                ? { backgroundColor: "#198754", color: "#ffffff", fontSize: "0.85rem", opacity: 0.95, cursor: "not-allowed" }
                : { color: "#6d5a82", fontSize: "0.85rem" }
            }
            onClick={onRequestCustomization}
            disabled={isCustomizationRequested}
            title={isCustomizationRequested ? "Customization already requested within the last 7 days" : "Customize Report"}
            aria-label="Customize Report"
          >
            {isCustomizationRequested ? (
              <FaCheck size={12} style={{ color: "#ffffff" }} />
            ) : (
              <FaFileAlt size={12} style={{ color: "#a06cff" }} />
            )}
            <span className="fw-semibold">
              {isCustomizationRequested ? "Customization Requested" : "Customize"}
            </span>
          </button>
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2 transition rounded-pill border-0 report-action-btn"
            style={{ color: "#1a237e", fontSize: "0.85rem" }}
            onClick={onBuyNow}
            aria-label="Buy Now"
          >
            <IoCartOutline size={14} style={{ color: "#1a237e" }} />{" "}
            <span className="fw-semibold">Buy Now</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportDetailsSidebar;
